import { useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';
import CurrencyTextFilter from './CurrencyTextFilter';
import SelectWithDynamicHintFilter from './SelectWithDynamicHintFilter/SelectWithDynamicHintFilter';
import PriceFilter from './PriceFilter';
import FILTER_TYPES from './constants';
import DateFilter from './DateFilter';
import SelectFilter from './SelectFilter';
import TextFilter from './TextFilter';

const useStyles = makeStyles(theme => ({
  filterBox: {
    position: 'relative',
    width: `calc(100% + ${theme.spacing(3)}px)`,
    minWidth: `calc(100% + ${theme.spacing(1.5)}px)`,
    height: 32,
    minHeight: 32,
    left: theme.spacing(-1.5),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(2),
    padding: '0px 7px 0px 14px',
    alignItems: 'flex-end',
    display: 'flex',
    marginTop: 16,
  },
  isEditableModeStyle: {
    left: 0,
    width: '100%',
  },
  transparent: {
    backgroundColor: 'transparent',
  },
  specialDateFilterPadding: {
    padding: '0px 12px 0px 14px',
    alignItems: 'center',
    cursor: 'default',
  },
}));

function FilterBox(props) {
  const containerElement = useRef();
  const {
    columnData: { filterType, isFilterable, includeCurrentAccount, customAccountUuidForFilter },
    isEditableMode,
  } = props;
  const classes = useStyles();
  const renderFilter = () => {
    const state = props.table?.getState();
    const filterProps = {
      ...props,
      filterValue: state.filter.find(element => element.id === props?.column.id)?.value,
      onChange: (k, v) => {
        props?.column?.setFilterValue(v, true);
      },
      tableFilters: state.filter,
      tableName: state.tableName,
      dataKey: props?.column.id,
      includeCurrentAccount: includeCurrentAccount,
      customAccountUuidForFilter: customAccountUuidForFilter,
    };

    switch (filterType) {
      case FILTER_TYPES.DATE: {
        return <DateFilter {...filterProps} containerElement={containerElement} />;
      }
      case FILTER_TYPES.SELECT: {
        return <SelectFilter {...filterProps} containerElement={containerElement} />;
      }
      case FILTER_TYPES.CHECKBOX: {
        return <SelectFilter {...filterProps} containerElement={containerElement} />;
      }
      case FILTER_TYPES.INPUT_CURRENCY: {
        return <CurrencyTextFilter {...filterProps} />;
      }
      case FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT: {
        return <SelectWithDynamicHintFilter {...filterProps} />;
      }
      case FILTER_TYPES.PRICE: {
        return <PriceFilter {...filterProps} />;
      }
      default:
        return <TextFilter {...filterProps} />;
    }
  };

  return (
    <div
      ref={containerElement}
      className={cx(classes.filterBox, {
        [classes.transparent]: !isFilterable,
        [classes.specialDateFilterPadding]: filterType === FILTER_TYPES.DATE,
        [classes.isEditableModeStyle]: isEditableMode,
      })}
    >
      {renderFilter()}
    </div>
  );
}

FilterBox.propTypes = {
  columnData: PropTypes.shape({
    filterType: PropTypes.oneOf([FILTER_TYPES.DATE, FILTER_TYPES.INPUT, FILTER_TYPES.SELECT]),
    isFilterable: PropTypes.bool,
  }).isRequired,
};

export default FilterBox;
